import BoldOTF from "../fonts/circe/circe-bold-65.otf"

import RegularOTF from "../fonts/circe/circe-regular-55.otf"

import LightOTF from "../fonts/circe/circe-light-35.otf"

export { BoldOTF, RegularOTF, LightOTF }
